<template>
    <WizardShell :mission="mission">
        <div class="row pt-1 mb-5 d-flex justify-content-center">
            <div class="col-auto">
                <MissionTransporteurCard :mission="mission" @transporteurUpdate="transporteurUpdate" />
            </div>
        </div>
        <div v-if="mission?.status === 'DRAFT' || mission?.status === 'PENDING'" class="row pt-1 mb-5 d-flex justify-content-center">
            <div class="col-auto">
                Choisissez le véhicule principal de la mission (le véhicule d'escorte ou le transporteur s'il est
                présent sur Argos).
            </div>
        </div>
        <template #actions>
            <ButtonDisplay @click="$emit('next')" :type="'start'" text="Suivant" :disabled="!hasTransporteur" />
        </template>
    </WizardShell>
</template>

<script>
import WizardShell from './WizardShell.vue'
import MissionTransporteurCard from '@/views/Missions/Components/MissionTransporteurCard.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'

export default {
    name: 'WizardTransporteur',
    props: ['mission'],
    components: { WizardShell, MissionTransporteurCard, ButtonDisplay },
    computed: {
        hasTransporteur() {
            return !!(this.mission?.transporteurId || this.mission?.transporteur?.id);
        }
    },
    methods: {
        transporteurUpdate(balise) { this.$emit('transporteurUpdate', balise.id); }
    }
}
</script>